import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const initialState = {
	resumeData: {},
	resumeLimits: {
		award: 0,
		certificate: 0,
		educations: 0,
		experience: 0,
		hobbies: 0,
		language: 0,
		project: 0,
		skill: 0,
		social: 0,
		tools: 0,
	},
	loading: false,
	error: null,
};

const resumeStore = (set: any) => ({
	...initialState,

	updateResumeData: (data: Record<string, any>) =>
		set((state: any) => ({ ...state, resumeData: { ...state.resumeData, ...data } })),

	updateResumeLimits: (limits: Partial<(typeof initialState)['resumeLimits']>) =>
		set((state: any) => ({ ...state, resumeLimits: { ...state.resumeLimits, ...limits } })),

	resetState: () => set({ ...initialState }),
});

const useResumeStore = create(devtools(resumeStore));

export const { updateResumeData, updateResumeLimits, resetState } = useResumeStore.getState();

export default useResumeStore;
